import Constants from '@/Constants';
import List from '@/models/List';
import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface Props {
    buttonMode?: boolean;

    course: List;
    customClass: string;
    customActiveClass: string;
    innerCustomClass?: string;
}

const CourseSelection: React.FC<Props> = (props: Props) => {
    const { course } = props;
    const { selectedCourseForInsertion } = useSelector((state: ApplicationState) => ({
        selectedCourseForInsertion: state.lists.selectedCourseForInsertion,
    }));

    return (
        <div className={'selection'}>
            <button className={'btn btn-link'}>
                {selectedCourseForInsertion && selectedCourseForInsertion.id === course.id ? (
                    <i className="material-icons outline checked">{Constants.icons.CHECK_CIRCLE}</i>
                ) : (
                    <div className="check" />
                )}
            </button>
        </div>
    );
};

export default CourseSelection;
